<c-card *transloco="let t">
  <c-card-body class="px-2" *ngIf="reports">

      <c-row>
        <c-col class="col-lg-6 col-12">
          <h1>{{ t('Reports Scheduling') }}</h1>

        </c-col>
        <c-col class="col-lg-6 col-12 text-end" *ngIf="!okService.isExtendedPrivacy()">
          <div class="btn-group mb-2" role="group">
            <button class="btn btn-success text-white" type="button" data-bs-toggle="collapse" data-bs-target="#collapseCreate" aria-expanded="false" aria-controls="collapseCreate">
              <i class="fa-solid fa-plus"></i> {{ t('Add a Scheduled Report') }}</button>
            <a href="https://okalone.zendesk.com/hc/en-gb/articles/35353118483089-How-to-Schedule-Automatic-Delivery-of-Reports" class="btn btn-primary" target="_new"><i class="fa fa-question-circle" aria-hidden="true"></i> {{ t('Help') }}</a>
          </div>
        </c-col>
      </c-row>
      <c-row>
        <c-col class="col-12">
          <div class="alert alert-info alert-dismissible fade show" role="alert" *ngIf="!okService.isDismissed('report_schedule_info')">
            <i class="fa-solid fa-circle-info"></i> {{ t('If you need a report emailed automatically to yourself or other monitors in your account please set them up here. A Scheduled Report consists of the Type of Report (No Location), Frequency of Delivery (Daily/Weekly/Monthly/Yearly), the monitors whom will receive it. In addition the filters are optional, you can filter the workers that appear in the report by either a certain Monitor who has those workers assigned to them, or the workers contained in a Group, or both.') }}
            <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close" (click)="okService.doDismiss('report_schedule_info')"></button>
          </div>
        </c-col>
      </c-row>

      <c-row class="row-md-6">

        <div class="collapse" id="collapseCreate">
          <div class="card m-3">
            <div class="card-header">
              <h3>{{ t('Add a Scheduled Report') }}</h3>
            </div>
            <div class="card-body"  id="collapseBodyCreate">
            <p>{{ t('Choose type, frequency, and monitors to include in the report') }}</p>
            <form [formGroup]="createFormGroup" cForm (ngSubmit)="createReport()">
              <div class="form-group row mb-2" >
                <label class="col-sm-3 col-form-label"><svg cIcon name="cil-options"></svg> {{ t('Type') }}</label>
                <div class="col-sm-8">
                  <ng-select [items]="type"
                            bindLabel="name"
                            bindValue="value"
                            formControlName="type">
                  </ng-select>
                </div>
              </div>
              <div class="form-group row mb-2" >
                <label class="col-sm-3 col-form-label"><svg cIcon name="cil-calendar"></svg> {{ t('Frequency') }}</label>
                <div class="col-sm-8">
                  <ng-select [items]="freq"
                            bindLabel="name"
                            bindValue="value"
                            formControlName="freq">
                  </ng-select>
                </div>
              </div>
              <div class="form-group row mb-2" >
                <label class="col-sm-3 col-form-label"><svg cIcon name="cil-shield-alt"></svg> {{ t('Send To') }}</label>
                <div class="col-sm-8">
                  <ng-select
                    [items]="okService.monitors"
                    bindLabel="name"
                    bindValue="id"
                    [multiple]="true"
                    formControlName="monitors">
                  </ng-select>
                </div>
              </div>

              <div class="form-group row mb-2" formGroupName="filter">
                <label  class="col-sm-3 col-form-label">
                  {{ t('Optional Filter:') }}
                </label>
                <div class="col-sm-4">
                  <ng-select
                  [items]="okService.monitors"
                  formControlName="monitor"
                  placeholder="{{ t('Monitor') }}"
                  bindLabel="name"
                  bindValue="id">
                  </ng-select>
                </div>

                <ng-container *ngIf="okService.groups.length > 0 && okService.hasFeature('groups')">
                  <div class="col-sm-4">
                    <ng-select
                      [items]="okService.groups"
                      formControlName="group"
                      bindLabel="name"
                      bindValue="id"
                      placeholder="{{ t('Group') }}">
                    </ng-select>
                  </div>
                </ng-container>
              </div>

              <div class="alert alert-warning" role="alert" *ngIf="form_error">
                {{form_error}}
              </div>

              <button cButton class="btn btn-primary text-white my-2" type="submit">
                <i class="fa-solid fa-check"></i> {{ t('Add Scheduled Report Now') }}
              </button>
            </form>
          </div>
          </div>
        </div>

      </c-row>

      <c-row class="justify-content-end">
        <c-col class="col-12 col-lg-6">

          <c-row class="justify-content-end">

            <c-col xs="auto" class="mb-2" *ngIf="pagination.totalPages > 1">
              <c-input-group  class="text-end">
                <span cInputGroupText><i class="fa-solid fa-arrow-down-1-9"></i></span>
                <select aria-label="Default select example" name="page" cSelect (change)="updateFilter()"  [(ngModel)]="pagination.page">
                  <option *ngFor="let p of pagination.pageArray" value="{{p}}">{{p}}</option>
                </select>
              </c-input-group>
            </c-col>
            <c-col xs="auto" class="mb-2">
              <c-input-group>
                <span cInputGroupText><svg cIcon class="me-2" name="cil-sort-ascending"></svg></span>
                <select aria-label="Default select example" (change)="updateFilter()" name="sort" cSelect [(ngModel)]="sort">
                  <option value="newest">{{ t('Newest') }}</option>
                  <option value="oldest">{{ t('Oldest') }}</option>
                  <option value="name">{{ t('Name') }}</option>
                  <option value="last_send">{{ t('Last Sent') }}</option>"
                  <option value="next_send">{{ t('Next Delivery') }}</option>
                </select>
              </c-input-group>
            </c-col>
          </c-row>
        </c-col>
      </c-row>

          <c-row *ngIf="reports">
            <c-col>

              <table
              [hover]="true"
              [responsive]="true"
              [striped]="true"
              align="middle"
              cTable
              class="mb-0 border"
              >
                <thead>
                  <tr>
                    <th scope="col"></th>
                    <!-- <th scope="col">{{ t('Type') }}</th> -->
                    <th scope="col">{{ t('Name') }}</th>
                    <!-- <th scope="col">{{ t('Frequency') }}</th> -->
                    <th scope="col">{{ t('Monitors') }}</th>
                    <th scope="col">{{ t('Filters') }}</th>
                    <th scope="col">{{ t('Last Sent') }}</th>
                    <th scope="col">{{ t('Next Delivery') }}</th>
                  </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let report of reports">
                      <td>
                        <button  type="button" class="btn btn-info mb-2 me-2 text-white" (click)="editReport(report)">
                          <svg cIcon class="me-2" name="cil-pencil"></svg>
                          {{ t('Edit') }}
                        </button>
                      </td>
                      <!-- <td>
                         <div>
                          {{report.type_str}}
                        </div>
                      </td> -->
                      <td>
                        <span><b class="fs-6">{{report.name}}</b></span>
                      </td>
                      <!-- <td>
                        {{report.freq_str}}
                      </td> -->
                      <th>
                        <div class="small text-medium-emphasis">
                          <ng-container *ngFor="let monitor_name of report.monitor_names; let i = index">
                            <span class="pointer" routerLink="/mgmt/monitor/{{report.monitor_ids[i]}}">{{ monitor_name }}&nbsp;&nbsp;</span>
                          </ng-container>
                        </div>
                      </th>
                      <td class="small text-medium-emphasis">
                        <span *ngIf="report.filter_group">{{t('Group')}}: {{report.filter_group}} <br/></span>
                        <span *ngIf="report.filter_monitor">{{t('Monitor')}}: {{report.filter_monitor}} <br/></span>
                      </td>
                      <td>
                        <div class="small text-medium-emphasis">
                          {{report.last_send}}
                        </div>
                      </td>
                      <td>
                        <div class="small text-medium-emphasis">
                          {{report.next_send}}
                        </div>
                      </td>
                    </tr>
                  </tbody>

              </table>

            </c-col>
          </c-row>
          <c-row class="justify-content-end" *ngIf="pagination.totalPages>1">

            <c-col xs="auto" class="mt-2">
              <c-input-group  class="text-end">
                <span cInputGroupText><i class="fa-solid fa-arrow-down-1-9"></i></span>
                <select aria-label="Default select example" name="page" cSelect (change)="updateFilter()"  [(ngModel)]="pagination.page">
                  <option *ngFor="let p of pagination.pageArray" value="{{p}}">{{p}}</option>
                </select>
              </c-input-group>
            </c-col>

          </c-row>


  </c-card-body>

  <ng-container>
    <div class="modal fade" id="editReportModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="editReportModalLabel" *ngIf="editFormGroup">{{ t('Edit Name', {Name: edit_report.name }) }}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body" *ngIf="editFormGroup">
            <form [formGroup]="editFormGroup" cForm (ngSubmit)="submitEditReport()">
                  <div class="form-group row mb-2" >
                    <label class="col-sm-3 col-form-label"><svg cIcon name="cil-options"></svg> {{ t('Type') }}</label>
                    <div class="col-sm-8">
                      <ng-select
                        [items]="type"
                        bindLabel="name"
                        bindValue="value"
                        formControlName="type">
                      </ng-select>
                    </div>
                  </div>
                  <div class="form-group row mb-2" >
                    <label class="col-sm-3 col-form-label"><svg cIcon name="cil-calendar"></svg> {{ t('Frequency') }}</label>
                    <div class="col-sm-8">
                      <ng-select [items]="freq"
                                bindLabel="name"
                                bindValue="value"
                                formControlName="freq"
                                placeholder="{{ t('Please choose...') }}">
                      </ng-select>
                    </div>
                  </div>
                  <div class="form-group row mb-2" >
                    <label class="col-sm-3 col-form-label"><svg cIcon name="cil-shield-alt"></svg> {{ t('Send To') }}</label>
                    <div class="col-sm-8">
                      <ng-select [items]="okService.monitors"
                                bindLabel="name"
                                bindValue="id"
                                [multiple]="true"
                                formControlName="monitors"
                                placeholder="{{ t('Please choose...') }}">
                      </ng-select>
                    </div>
                  </div>

                  <div class="form-group row mb-2 justify-content-between">
                    <label  class="col-sm-3 col-form-label">
                      {{ t('Optional Filters:') }}
                    </label>
                    <div class="form-group col-sm-9" formGroupName="filter">

                      <div class="col-sm-3 mb-2">
                        <ng-select
                        [items]="okService.monitors"
                        formControlName="monitor"
                        placeholder="{{ t('Monitor') }}"
                        bindLabel="name"
                        bindValue="id">
                      </ng-select>
                      </div>

                      <ng-container *ngIf="okService.groups.length > 0 && okService.hasFeature('groups')">
                        <div class="col-sm-3">
                          <ng-select
                          [items]="okService.groups"
                          formControlName="group"
                          bindLabel="name"
                          bindValue="id"
                          placeholder="{{ t('Group') }}">
                        </ng-select>
                        </div>
                      </ng-container>
                    </div>
                  </div>

                  <div class="alert alert-warning" role="alert" *ngIf="form_error">
                    {{form_error}}
                  </div>

                <div class="row justify-content-between">
                  <div class="col">
                    <button cButton class="px-4 text-white btn-info" type="submit">
                      <i class="fa-solid fa-check"></i> {{ t('Update Report') }}
                    </button>
                  </div>
                  <div class="col text-end">
                    <button cButton class="my-2" color="danger" class="text-white" (click)="doDelete()">
                      <i class="fa-solid fa-x"></i> {{ t('Delete') }}
                    </button>
                  </div>
                </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</c-card>
